











































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';

interface ResponseData {
    Items: ResponseDataItem[];
    Config: {
        CountShift: number;
        CountExtendedShift: number;
    };
}
interface ResponseDataItem {
    Name: string;
    Shifts: number[];
    SubTotal: number | null;
    ExtendedShifts: number[];
    Total: number | null;
    Children: ResponseDataItem[];
}

@Component({
    components: {CSimpleTable},
})
export default class PlanResSummaryIndicator extends Vue {
    @Prop() params!: any;
    @Prop() tabData!: any;

    private loading: boolean = false;
    private data: ResponseData | null = null;
    private items: any[] = [];

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    get idPlanRes() {
        return this.tabData?.idPlanRes;
    }

    @Watch('data', {deep: true})
    onDataChange(value: ResponseDataItem) {
        this.items = this.getItems();
    }

    created() {
        this.getData();
    }

    async getData() {
        const timerId = setTimeout(() => (this.loading = true), 100);
        try {
            const {data} = await this.$http.get(`${this.$api.journals.planResSummaryIndicator}/GetAll`, {
                params: {
                    idPlanRes: this.idPlanRes,
                },
            });
            this.data = data;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    getItems() {
        if (this.data === null) return [];
        let depth = -1;
        const result: any = [],
            callback = (item: ResponseDataItem, index: number, array: ResponseDataItem[]) => {
                if (index === 0) depth += 1;
                const row = {
                    depth,
                    subrow: depth > 0,
                    ...item,
                    childrensShown: true,
                    hasChildrens: item.Children && item.Children.length > 0,
                    attrs: {
                        style: {
                            display: '',
                        },
                    },
                };
                result.push(row);
                if (item.Children && item.Children.length > 0) item.Children.forEach(callback);
                if (index === array.length - 1) depth -= 1;
            };
        this.data.Items.forEach(callback);
        return result;
    }

    onToggleIconClick(item: any, index: number) {
        const data = this.items.slice(index + 1),
            items = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].depth > item.depth) items.push(data[i]);
            else break;
        }
        item.childrensShown = !item.childrensShown;

        const displayState = item.childrensShown ? '' : 'none';
        let skipedDepth = null;
        for (let j = 0; j < items.length; j++) {
            const el = items[j];
            if (item.childrensShown) {
                if (skipedDepth && el.depth > skipedDepth) continue;
                else skipedDepth = null;
                if (el.hasChildrens && el.childrensShown === false) {
                    el.attrs.style.display = displayState;
                    skipedDepth = el.depth;
                }
            }
            el.attrs.style.display = displayState;
        }
    }
}
